import contect from './reducers'

export { showContect, hideContect } from './actions'
export { getContect } from './selectors'

export default contect
